import type { DialogContentProps } from 'reka-ui';

// This is a fixup to avoid the warning emitted by Reka UI for modals without a description.
// It seems to be a NuxtUI bug — it should set :aria-describedby="undefined" when no description is provided,
// as required by Reka UI (see https://reka-ui.com/docs/components/dialog#description).
// The cast is necessary because the content type only accepts the props of DialogContent.
export const modalNoDescAriaFixupProps = { content: { 'aria-describedby': undefined } as Partial<DialogContentProps> };
